import { createRoot } from "react-dom/client";
import { AppPublic } from "./AppPublic.tsx";
import "./index.css";
import "./styles/marketing.css";

createRoot(document.getElementById("root")!).render(<AppPublic />);
